import { Col, Input, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import React from 'react';

const UserProfile = () => {
  return (
    <>
      <div className='font-roboto-medium text-[18px] font-medium mt-3'>
          {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
        </div>
        <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_USERNAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_TITLE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_FIRST_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
              />
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_GENDER")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_PHONE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
              />
            </div>
            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_LAST_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                disabled
              />
            </div>
          </Col>
        </Row>
        <hr className='border border-[#D9D9D9] my-10' />
        <div className='font-roboto font-semibold text-[20px]'>
          {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
        </div>
        <Row>
          <Col span={10}>
            <div className='font-roboto-medium text-[18px] font-medium mt-3'>
              {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
            </div>
          </Col>
          <Col span={4}></Col>
          <Col span={10}>
            <div className='font-roboto-medium text-[18px] font-medium mt-3'>
              {t("LOGIN_COMPLETION:ADDRESS_INFORMATION")}
            </div>
          </Col>
        </Row>
        
        <Row className='mt-3'>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_EMAIL")}
            </p>
            <Input 
              style={{ width: '100%' }} 
              size='large' 
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_EMAIL")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_NIK")}
            </p>
            <Input 
              style={{ width: '100%' }} 
              size='large' 
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NIK")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_BIRTH_PLACE")}
            </p>
            <Input 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_BIRTH_PLACE")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_BIRTH_DATE")}
            </p>
            <Input 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_BIRTH_DATE")} )}
            />
          </div>
        </Col>
        <Col span={4}> </Col>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_COUNTRY")}
            </p>
            <Select 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_COUNTRY")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_PROVINCE")}
            </p>
            <Select 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_PROVINCE")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_DISTRICT")}
            </p>
            <Select 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_DISTRICT")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_SUBDISTRICT")}
            </p>
            <Select 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_SUBDISTRICT")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_URBAN_VILLAGE")}
            </p>
            <Select 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:SELECT", { field: t("LOGIN_COMPLETION:LBL_URBAN_VILLAGE")} )}
            />
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_ADDRESS")}
            </p>
            <TextArea 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS")} )}
            />
          </div>
          <div className='mt-3'>
            <Row>
              <Col span={9}>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD")}
                </p>
              </Col>
              <Col span={2}></Col>
              <Col span={9}>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("LOGIN_COMPLETION:LBL_HAMLET")}
                </p>
              </Col>
              <Col span={4}></Col>
            </Row>
            <Row>
              <Col span={9}>
                <Input 
                  style={{ width: '100%' }} 
                  size="large"
                  placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD")} )}
                />
              </Col>
              <Col span={2}></Col>
              <Col span={9}>
                <Input 
                  style={{ width: '100%' }} 
                  size="large"
                  placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_HAMLET")} )}
                />
              </Col>
              <Col span={4}></Col>
            </Row>
          </div>
          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_POSTAL_CODE")}
            </p>
            <Input 
              style={{ width: '100%' }} 
              size='large'
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_POSTAL_CODE")} )}
            />
          </div>
          </Col>
        </Row>
    </>
  );
};

export default UserProfile;